module.exports = __webpack_public_path__ + "img/1745567632_njYg.50defd33.jpg";